import { Outlet, Route } from 'react-router-dom'

import { LootboxMain } from './LootboxMain'

export const LootboxRoutes = [
    <Route key='loot-boxes' element={<Outlet />}>
        <Route index element={<LootboxMain />} />
    </Route>,
]
